import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=14bd27ee&scoped=true"
import script from "./PhoneNumberInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneNumberInput.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PhoneNumberInput.vue?vue&type=style&index=0&id=14bd27ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bd27ee",
  null
  
)

export default component.exports